// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"4aa9c0b4","453":"76e288dd","859":"4be9c1a3"}[chunkId] + ".chunk.js";
};